"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportSpreadsheet = exportSpreadsheet;
function exportSpreadsheet(rows, columns, options) {
    var _a, _b;
    const dataToExport = (_a = options === null || options === void 0 ? void 0 : options.dataOverride) !== null && _a !== void 0 ? _a : rows;
    const filename = (_b = options === null || options === void 0 ? void 0 : options.title) !== null && _b !== void 0 ? _b : `datatest-${new Date().toLocaleString()}`;
    const parsedData = dataToExport.map((row) => row.cells.map((cell) => cell.value));
    let spreadsheetResult;
    let download;
    if (options === null || options === void 0 ? void 0 : options.includeColumnHeaders) {
        const columnData = columns.map((c) => c.label);
        console.log(columnData);
        parsedData.unshift(columnData);
    }
    if (options === null || options === void 0 ? void 0 : options.xlsx) {
        const XLSX = options.xlsx;
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(parsedData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const xlsxBuffer = XLSX.write(workbook, {
            type: 'buffer',
            bookType: 'xlsx',
        });
        const blob = new Blob([xlsxBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        spreadsheetResult = url;
        download = `${filename}.xlsx`;
    }
    else {
        const csvContent = 'data:text/csv;charset=utf-8,' +
            encodeURIComponent(parsedData.map((row) => row.join(',')).join('\n'));
        spreadsheetResult = csvContent;
        download = `${filename}.csv`;
    }
    const link = document.createElement('a');
    link.href = spreadsheetResult;
    link.download = download;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
//# sourceMappingURL=utils.js.map